import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

// Async thunk for global search
export const performGlobalSearch = createAsyncThunk(
  'search/performGlobalSearch',
  async (query, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${apiUrl}/Search/?q=${query}`,  {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  isSearchOpen: false,
  searchResults: {
    orders: [],
    transactions: [],
    profiles: [],
    products: []
  },
  totalResults: 0,
  loading: false,
  error: null,
  searchQuery: ''
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchOpen: (state, action) => {
      state.isSearchOpen = action.payload;
    },
    clearSearch: (state) => {
      state.searchResults = initialState.searchResults;
      state.totalResults = 0;
      state.searchQuery = '';
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(performGlobalSearch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(performGlobalSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.searchResults = {
          orders: action.payload.orders || [],
          transactions: action.payload.transactions || [],
          profiles: action.payload.profiles || [],
          products: action.payload.products || []
        };
        state.totalResults = action.payload.total_results;
      })
      .addCase(performGlobalSearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'An error occurred';
      });
  }
});

export const { setSearchOpen, clearSearch, setSearchQuery } = searchSlice.actions;
export default searchSlice.reducer;